// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* -------------------------
   Pleasant Green Themed Internship Card
------------------------- */

.internship-card {
  position: relative;
  background: radial-gradient(circle at top left, #e8fce8, #ffffff);
  border-radius: 16px;
  padding: 16px 20px 18px;
  box-shadow: 0 18px 45px rgba(0, 90, 40, 0.18);
  border: 1px solid rgba(34, 197, 94, 0.45);
  font-size: 0.95rem;
  line-height: 1.5;
  pointer-events: auto;
  animation: internship-fade 0.25s ease-out;

  /* ⬅ ADDED: Scrollable on small screens */
  max-height: calc(100vh - 130px);
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

@media (max-width: 768px) {
  .internship-card {
    padding: 14px 14px 16px;
    border-radius: 12px;

    /* ⬅ ADDED: mobile-friendly height */
    max-height: calc(100vh - 24px);
  }
}

/* Fade animation */
@keyframes internship-fade {
  from { opacity: 0; }
  to { opacity: 1; }
}

/* Pill */
.internship-card-pill {
  display: inline-flex;
  align-items: center;
  padding: 4px 10px;
  border-radius: 999px;
  background: rgba(34, 197, 94, 0.18);
  font-size: 0.78rem;
  font-weight: 600;
  margin-bottom: 6px;
  color: #166534;
}

/* Title */
.internship-card-title {
  margin: 2px 0 6px;
  font-size: 1.05rem;
  font-weight: 700;
  color: #14532d;
}

.internship-card-text {
  margin: 4px 0;
  color: #064e3b;
}

.internship-card-subtitle {
  margin-top: 8px;
  font-weight: 600;
  color: #14532d;
}

.internship-card-list {
  margin: 4px 0 8px 18px;
}

.internship-card-list li {
  margin-bottom: 3px;
  color: #064e3b;
}

.emoji-bullet {
  margin-right: 4px;
}

/* Close Button */
.internship-card-close {
  position: absolute;
  top: 8px;
  right: 8px;
  background: rgba(34, 197, 94, 0.2);
  border-radius: 999px;
  cursor: pointer;
  padding: 3px;
  color: #065f46;
  border: none;
  display: flex;
  align-items: center;
  transition: 0.15s;
}

.internship-card-close:hover {
  background: rgba(34, 197, 94, 0.3);
  transform: scale(1.03);
}`, "",{"version":3,"sources":["webpack://./src/styles/InternshipInfoCard.css"],"names":[],"mappings":"AAAA;;2BAE2B;;AAE3B;EACE,kBAAkB;EAClB,iEAAiE;EACjE,mBAAmB;EACnB,uBAAuB;EACvB,6CAA6C;EAC7C,yCAAyC;EACzC,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,yCAAyC;;EAEzC,yCAAyC;EACzC,+BAA+B;EAC/B,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE;IACE,uBAAuB;IACvB,mBAAmB;;IAEnB,oCAAoC;IACpC,8BAA8B;EAChC;AACF;;AAEA,mBAAmB;AACnB;EACE,OAAO,UAAU,EAAE;EACnB,KAAK,UAAU,EAAE;AACnB;;AAEA,SAAS;AACT;EACE,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,oBAAoB;EACpB,mCAAmC;EACnC,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;AAChB;;AAEA,UAAU;AACV;EACE,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,kCAAkC;EAClC,oBAAoB;EACpB,eAAe;EACf,YAAY;EACZ,cAAc;EACd,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,kCAAkC;EAClC,sBAAsB;AACxB","sourcesContent":["/* -------------------------\n   Pleasant Green Themed Internship Card\n------------------------- */\n\n.internship-card {\n  position: relative;\n  background: radial-gradient(circle at top left, #e8fce8, #ffffff);\n  border-radius: 16px;\n  padding: 16px 20px 18px;\n  box-shadow: 0 18px 45px rgba(0, 90, 40, 0.18);\n  border: 1px solid rgba(34, 197, 94, 0.45);\n  font-size: 0.95rem;\n  line-height: 1.5;\n  pointer-events: auto;\n  animation: internship-fade 0.25s ease-out;\n\n  /* ⬅ ADDED: Scrollable on small screens */\n  max-height: calc(100vh - 130px);\n  overflow-y: auto;\n  -webkit-overflow-scrolling: touch;\n}\n\n@media (max-width: 768px) {\n  .internship-card {\n    padding: 14px 14px 16px;\n    border-radius: 12px;\n\n    /* ⬅ ADDED: mobile-friendly height */\n    max-height: calc(100vh - 24px);\n  }\n}\n\n/* Fade animation */\n@keyframes internship-fade {\n  from { opacity: 0; }\n  to { opacity: 1; }\n}\n\n/* Pill */\n.internship-card-pill {\n  display: inline-flex;\n  align-items: center;\n  padding: 4px 10px;\n  border-radius: 999px;\n  background: rgba(34, 197, 94, 0.18);\n  font-size: 0.78rem;\n  font-weight: 600;\n  margin-bottom: 6px;\n  color: #166534;\n}\n\n/* Title */\n.internship-card-title {\n  margin: 2px 0 6px;\n  font-size: 1.05rem;\n  font-weight: 700;\n  color: #14532d;\n}\n\n.internship-card-text {\n  margin: 4px 0;\n  color: #064e3b;\n}\n\n.internship-card-subtitle {\n  margin-top: 8px;\n  font-weight: 600;\n  color: #14532d;\n}\n\n.internship-card-list {\n  margin: 4px 0 8px 18px;\n}\n\n.internship-card-list li {\n  margin-bottom: 3px;\n  color: #064e3b;\n}\n\n.emoji-bullet {\n  margin-right: 4px;\n}\n\n/* Close Button */\n.internship-card-close {\n  position: absolute;\n  top: 8px;\n  right: 8px;\n  background: rgba(34, 197, 94, 0.2);\n  border-radius: 999px;\n  cursor: pointer;\n  padding: 3px;\n  color: #065f46;\n  border: none;\n  display: flex;\n  align-items: center;\n  transition: 0.15s;\n}\n\n.internship-card-close:hover {\n  background: rgba(34, 197, 94, 0.3);\n  transform: scale(1.03);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
